import React from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
import { Section, CountdownTimer, CTAButton } from './Shared';
export const Pricing = () => {
  return <Section id="pricing" className="bg-brand-surfaceLight/30 rounded-3xl my-12" data-id="element-232">
      <div className="text-center mb-10" data-id="element-233">
        <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-gold mb-6" data-id="element-234">
          ⏰ PRECIO DE LANZAMIENTO
        </h2>
        <CountdownTimer data-id="element-235" />
        <p className="mt-4 text-red-500 font-medium" data-id="element-236">
          ⚠️ ESTE PRECIO CIERRA PRONTO
        </p>
        <p className="mt-1 text-brand-text/70 text-sm" data-id="element-237">
          Después sube $8.000 ARS. No vuelve.
        </p>
        <p className="mt-4 text-brand-gold/80 text-sm font-medium" data-id="element-238">
          🔴 Quedan pocos cupos al precio de lanzamiento
        </p>

        <div className="max-w-md mx-auto mt-2" data-id="element-239">
          <div className="w-full bg-white rounded-full h-2.5 border border-brand-pink/30 overflow-hidden shadow-inner" data-id="element-240">
            <div className="bg-brand-green h-2.5 rounded-full" style={{
            width: '68%'
          }} data-id="element-241"></div>
          </div>
          <p className="text-xs text-brand-text/60 mt-2" data-id="element-242">68% tomados</p>
        </div>
      </div>

      <div className="max-w-xl mx-auto" data-id="element-243">
        <div className="glass-panel rounded-3xl p-8 md:p-10 flex flex-col border-brand-gold relative shadow-[0_10px_40px_rgba(212,175,55,0.15)] bg-white/80 text-center" data-id="element-244">
          <div className="mb-6" data-id="element-245">
            <h4 className="text-2xl font-serif font-bold mb-2 text-brand-text" data-id="element-246">
              MEGAPACK CÓDIGO DE ABUNDANCIA
            </h4>
            <p className="text-brand-gold/90 font-medium" data-id="element-247">
              3 Tomos PDF + Audio MP3 + Script de Ventas
            </p>
          </div>

          <div className="mb-8" data-id="element-248">
            <div className="text-5xl font-bold text-brand-text mb-2" data-id="element-249">
              $19.990{' '}
              <span className="text-xl text-brand-text/70 font-normal" data-id="element-250">
                ARS
              </span>
            </div>
          </div>

          <div className="mt-auto" data-id="element-251">
            <CTAButton fullWidth className="text-lg py-5 animate-pulse-slow" href="https://www.lumenakasha.com/cart/46699505975485:1" data-id="element-252">
              🌟 QUIERO MANIFESTAR AHORA — $19.990 🌟
            </CTAButton>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap gap-6 mt-12 text-sm text-brand-muted flex-row items-start justify-center" data-id="element-253">
        <div className="flex items-center" data-id="element-254">
          <Lock className="w-4 h-4 mr-2" data-id="element-255" /> Pago 100% seguro
        </div>
        <div className="flex items-center" data-id="element-256">
          <Zap className="w-4 h-4 mr-2" data-id="element-257" /> Acceso inmediato
        </div>
        <div className="flex items-center" data-id="element-258">
          <Shield className="w-4 h-4 mr-2" data-id="element-259" /> Garantía 7 días
        </div>
        <div className="flex items-center" data-id="element-260">
          <CreditCard className="w-4 h-4 mr-2" data-id="element-261" /> Mercado Pago · Tarjeta ·
          Transferencia
        </div>
      </div>
    </Section>;
};